export const enum RedactionMode {
  // eslint-disable-next-line no-unused-vars
  SHOW_NONE = 'SHOW_NONE',
  // eslint-disable-next-line no-unused-vars
  SHOW_ALL = 'SHOW_ALL',
  // eslint-disable-next-line no-unused-vars
  SHOW_SOME = 'SHOW_SOME',
}
